module.exports = __webpack_public_path__ + "img/img_banner_project1_0.0534ddcb.jpg";